// ── src/app/pipes/order-status-badge.pipe.ts
import { Pipe, PipeTransform } from '@angular/core';
import { BadgeCfg, ORDER_STATUS_BADGE } from '../enum/order-status/order-status-badge.map';
import { OrderStatusEnum } from '../enum/order-status/order-status.enum';

@Pipe({ name: 'orderStatusBadge', standalone: true })
export class OrderStatusBadgePipe implements PipeTransform {
  transform(value: number | null | undefined): BadgeCfg | null {
    if (value === null || value === undefined) return null;
    return ORDER_STATUS_BADGE[value as OrderStatusEnum] ?? null;
  }
}
